/*
|--------------------------------------------------------------------------
| Mutation Types
|--------------------------------------------------------------------------
*/
export const SET_USER = 'SET_USER';
export const UNSET_USER = 'UNSET_USER';

/*
|--------------------------------------------------------------------------
| Initial State
|--------------------------------------------------------------------------
*/
const initialState = {
    name: null,
    email: null,
    avatar: null
};

/*
|--------------------------------------------------------------------------
| Mutations
|--------------------------------------------------------------------------
*/
const mutations = {
    [SET_USER](state, payload) {
        state.name = payload.user.name;
        state.email = payload.user.email;
        state.avatar = payload.user.avatar;
        console.log('set user', payload)
    },
    [UNSET_USER](state, payload) {
        state.name = null;
        state.email = null;
        state.avatar = null;
    },
    SET_AVATAR(state, url) {
        state.avatar = url;
    }
};

/*
|--------------------------------------------------------------------------
| Actions
|--------------------------------------------------------------------------
*/
const actions = {
    setAuthUser: (context, user) => {
        context.commit(SET_USER, {user})
    },
    unsetAuthUser: (context) => {
        context.commit(UNSET_USER);
    },
    SET_AVATAR({commit}, url) {
        commit('SET_AVATAR', url)
    },
};

/*
|--------------------------------------------------------------------------
| Getters
|--------------------------------------------------------------------------
*/
const getters = {
    isLoggedIn: (state) => {
        return !!(state.name && state.email);
    },
    userName: (state) => {
        return state.name
    },
    avatar: (state) => {
        return state.avatar
    }
};

/*
|--------------------------------------------------------------------------
| Export the module
|--------------------------------------------------------------------------
*/
export default {
    namespaced: true,
    state: initialState,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/auth.js